import React, { FC } from 'react';

import { getAccess } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Access/utils';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

interface INetworkTab {}

export const AccessTab: FC<INetworkTab> = () => {
  const { resourceType } = useActiveResourceContext();

  return <>{getAccess(resourceType)}</>;
};
